import { PUBLICATIONS } from '../constants/publications'

export const newLabelMapping = {
    Journal: PUBLICATIONS.journal,
    Congress: PUBLICATIONS.congress,
    Manuscript: PUBLICATIONS.manuscript,
    Presentation: PUBLICATIONS.presentation,
    DataOnFile: PUBLICATIONS.dataOnFile,
} as const

export type LabelKey = keyof typeof newLabelMapping
